import { Component, OnInit, Input } from '@angular/core';
import { CartService } from 'app/cart/cart.service';
import { SharedService } from 'app/shared.service';

@Component({
    selector: 'app-ticket-conf',
    templateUrl: './ticket-select.component.html',
    styleUrls: ['./ticket-select.component.scss']
})
export class TicketConfComponent implements OnInit {
    @Input()
    product;
    @Input()
    odds;
    @Input()
    productScopeId;

    ticketAmount = [];

    constructor(
        private cartService: CartService,
        private sharedService: SharedService
    ) {}

    ngOnInit() {
        this.ticketAmount = Array.from(Array(this.product.maxQuantity))
            .fill(0)
            .map((x, i) => i + 1);

        if (this.productScopeId !== undefined) {
            this.cartService.filterProductsByScopeId(this.productScopeId);
        }
    }

    /*
     * @param {Number} amount
     *
     * This method is called when user clicks
     * on a ticket number to select.
     *
     * Sets add the amount to the global ticket amount
     * or removes it if the selected amount is 0.
     */
    selectTicket(amount) {
        this.product.amount = amount;

        if (amount === 0) {
            this.cartService.removeProduct(this.product, this.odds);
        } else {
            this.cartService.addProduct(this.product, this.odds);
        }

        /*
         * Track via GTM.
         */
        this.sharedService.pushCustomToDataLayer({
            event: 'view_item',
            ecommerce: {
                currency: 'EUR',
                value: this.cartService.getTotalPriceWithoutDiscount(),
                items: this.cartService.getProductsForGTMTracking()
            }
        });
    }

    getActive() {
        return this.cartService.getActive(this.product) || 0;
    }
}
